<ng-container *transloco="let t">
    <section class="my-8 text-center">
        <tui-block-status>
            <img tuiSlot="top" alt="not found" src="assets/images/304.svg" class="image" />
            <span class="text-gray-700 font-medium">{{ title ?? t('empty') }}</span>
        </tui-block-status>
    </section>
</ng-container>
